import React from "react";
import { TFunction } from "i18next";
import { Tooltip } from "@mui/material";
import classnames from "classnames";
import { EyeIcon } from "@aureskonnect/react-ui";

import ErrorToast from "@components/Common/ErrorTost";
import { onKeyboardActivate } from "@helpers/a11y";

import { shopHasActiveFidelity } from "../../helpers";

type Props = {
    row: FidelityRow;
    shopsFidelityData: ShopsFidelityData;
    dataArchive: string[];
    isLoading: boolean;
    activateFidelity: () => void;
    t: TFunction;
};

export default function UnarchiveIconButton({
    row,
    shopsFidelityData,
    dataArchive,
    isLoading,
    activateFidelity,
    t,
}: Props) {
    const isAlreadyArchived = dataArchive.includes(row.Id);

    const handleClick = () => {
        if (shopHasActiveFidelity(shopsFidelityData, row)) {
            ErrorToast(
                t(
                    "Attention,a shop cannot have more than one fidelity settings"
                )
            );
        } else {
            activateFidelity();
        }
    };

    return (
        <Tooltip title={isAlreadyArchived ? "" : t("Unarchive")}>
            <div
                data-testid={`fidelity-shops-unarchive-icon-${row.Id}`}
                role="button"
                tabIndex={isAlreadyArchived || isLoading ? -1 : 0}
                aria-label={t("Unarchive")}
                aria-disabled={isAlreadyArchived || isLoading}
                onKeyDown={onKeyboardActivate(handleClick)}
            >
                <EyeIcon
                    height={25}
                    width={25}
                    style={{ cursor: "pointer" }}
                    onClick={handleClick}
                    className={classnames(
                        "pointer__clz mt-2 mr-2 cmn_icn_BTunarchive",
                        {
                            "not-allowed-icon__clz":
                                isAlreadyArchived || isLoading,
                        }
                    )}
                />
            </div>
        </Tooltip>
    );
}
